var _circle, _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSOhm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4265",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -11,
    y: 5,
    width: 46,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2929 18.7155C20.1069 18.7155 17.9203 18.6996 15.7347 18.7213C14.3869 18.7346 13.3823 17.8397 13.0866 16.8722C12.9487 16.4217 12.9042 15.9357 12.8516 15.4621C12.6098 13.2875 11.1535 11.3511 8.80462 11.0353C8.54439 11.0003 8.27903 10.9963 8.01581 10.9954C3.59363 10.983 -0.82855 10.9737 -5.25073 10.964C-5.46498 10.9633 -5.57234 10.8548 -5.57294 10.6384C-5.57294 8.94632 -5.57294 7.2542 -5.57294 5.56162C-5.57294 5.34789 -5.47136 5.24073 -5.26827 5.24014C-0.789234 5.23392 3.68977 5.23082 8.16879 5.21974C9.24987 5.21708 10.0246 5.73722 10.5664 6.6733C10.869 7.19566 10.9668 7.78232 11.0518 8.3774C11.2706 9.90055 11.8637 11.2145 13.1102 12.1315C13.8771 12.6955 14.7454 12.9368 15.6799 12.9381C20.1803 12.9439 24.6807 12.9496 29.1811 12.9554C29.4004 12.9554 29.5103 13.0689 29.5105 13.2959C29.5105 14.9881 29.5105 16.6802 29.5105 18.3728C29.5105 18.6783 29.5097 18.6796 29.2136 18.6796C26.9065 18.6796 24.5991 18.6796 22.2921 18.6796V18.7155H22.2929Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.878479 18.6804C-4.00378 18.6804 -7.12954 18.6804 -10.2548 18.6804C-10.5715 18.6804 -10.5723 18.6786 -10.5723 18.3495C-10.5723 16.6504 -10.5723 14.9511 -10.5723 13.2515C-10.5723 12.9583 -10.5693 12.9557 -10.2861 12.9552C-4.10635 12.949 2.07377 12.9419 8.25346 12.9375C9.76184 12.9366 10.9839 14.2368 11.0121 15.8047C11.0348 17.0419 10.1917 18.3854 8.75084 18.6746C8.55001 18.7149 8.3402 18.7203 8.13466 18.7203C5.13028 18.7229 2.1259 18.722 -0.878911 18.722V18.6799L-0.878479 18.6804Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8329 10.9846C21.8 10.9846 18.767 10.9584 15.7343 10.997C14.464 11.013 13.1082 10.0777 12.9069 8.49251C12.7022 6.88108 13.7427 5.55878 15.1178 5.26877C15.2767 5.23507 15.4421 5.22266 15.6045 5.22266C21.8055 5.22665 28.0065 5.2333 34.2076 5.23951C34.5102 5.23951 34.511 5.24084 34.511 5.56233C34.511 7.25401 34.511 8.94614 34.511 10.6378C34.511 10.9611 34.5102 10.9624 34.188 10.9624C31.0695 10.9624 27.9515 10.9624 24.8329 10.9624V10.9846Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.19489 18.9658H18.7405V4.9534L5.19489 4.9534L5.19489 18.9658Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSOhm);
export default __webpack_public_path__ + "static/media/sOHM.c9f5bd876b3c8c89c01da804dfc72591.svg";
export { ForwardRef as ReactComponent };